import { Injectable } from '@angular/core';
import { JSONAdapter } from './json-adapter';

export class MessageServiceMunicipal {
    id: number;
    userId: number;
    subject: string;
    message: string;
    email: string;
    address: string;
    civility: string;
    firstName: string;
    lastName: string;
    phone: string;
    site: string;
    createdAt: Date;
    updatedAt: Date;
}


@Injectable({
    providedIn: 'root'
})
export class MessageServiceMunicipalAdapter extends JSONAdapter<MessageServiceMunicipal> {

    protected getMapper() {
      return {
        user_id: 'userId',
        first_name: 'firstName',
        last_name: 'lastName',
        created_at: 'createdAt',
        updated_at: 'updatedAt'
      };
    }

}
